import { types, flow, applySnapshot } from 'mobx-state-tree';
import { pick } from 'lodash';
import { makeRequest } from 'js/services/Network';
import ItemListing from '../types/ItemListing';

export default types
  .model('SellerItemsPage', {
    seller_name: '',
    items: types.optional(types.array(ItemListing), []),
    micro_store: '',
    page: 1,
    last_page: 0,
    count: 5,
    storeValue: 0,
    is_loading: false,
    seller_country: '',
  })
  .views(self => ({
    get hasMorePages() {
      return self.page < self.last_page;
    },
  }))
  .actions(self => ({
    load: flow(function* load(refresh = false) {
      let response;
      // console.log("self: ",self);
      if (!self.is_loading) {
        refresh && applySnapshot(self, {micro_store: self.micro_store});
        self.is_loading = true;
        try {
          response = yield makeRequest(
            'seller-items-data',
            {alias: self.micro_store},
              pick(self, ['page', 'count'])
          );
          self.seller_name = response.data.seller_name || '';
          self.storeValue = response.data.store_value;
          self.last_page = response.data.items.last_page;
          self.micro_store = response.data.micro_store;
          self.seller_country = response.data.seller_country || '';
          response.data.items.data.forEach(item => self.items.push(item));
          self.is_loading = false;
        } catch (error) {
          self.is_loading = false;
          throw error;
        }
      }
      return response;
    }),
    loadMore() {
      if (self.page < self.last_page) {
        self.page++;
        self.load();
      }
    },
  }));
